import React, {Component} from 'react';
import { PropTypes } from 'prop-types';
import { featureHelpers } from './feature-helpers';

export class RequireFeatureComponent extends Component {

  render() {
    const {
      children,
      hideDisplay,
      requiredFeatures,
      requiredForIntegrationTypes,
    } = this.props;

    if (featureHelpers.meetsFeatureRequirements(requiredFeatures, requiredForIntegrationTypes)) {
      return (
          <div>
            {children}
          </div>
      );
    }
    else {
      return hideDisplay;
    }
  }
}

RequireFeatureComponent.defaultProps = {
  hideDisplay: null
};

RequireFeatureComponent.propTypes = {
  features : PropTypes.object,
  featureActions : PropTypes.object,
  requiredFeatures : PropTypes.array.isRequired,
  /**
   * a list of integration types that this feature is required for,
   * if falsy it is assumed that all integration types require these features
   **/
  requiredForIntegrationTypes : PropTypes.array,
  hideDisplay: PropTypes.any,
};

export default RequireFeatureComponent;


// WEBPACK FOOTER //
// src/features/require-feature.component.js